import React from 'react';

import safari_portal_logo from 'components/shared/images/safari_portal.svg';
import Text from 'components/shared/Typography/Text';

const renderImageDefault = ({ logo }) => (
  <img
    src={(replaceHost(logo) || safari_portal_logo) + '?pdf'}
    alt="logo"
    style={{ maxHeight: '80px', maxWidth: '175px' }}
  />
);

function Logo({ logo, companyName, renderImage = renderImageDefault }) {
  return (
    <>
      {!logo && companyName ? (
        <Text hoefler italic style={{ fontSize: '18px' }}>
          {companyName}
        </Text>
      ) : (
        renderImage({ logo, companyName })
      )}
    </>
  );
}

export default Logo;

// todo: need to find solution for this hack
export function replaceHost(url) {
  const reg = /media.safariportal.app/;
  if (reg.test(url)) {
    return url.replace(reg, 'safariportal-media-production.s3.amazonaws.com');
  }

  return url;
}
